/**
 * @author mrdoob / http://mrdoob.com/
 */

import UI from './libs/ui'
import * as use from '@tensorflow-models/universal-sentence-encoder'
import _ from 'lodash'
import fuzz from 'wordfuzz'
import uniqid from 'uniqid'
var UserTab = function (editor) {

    var signals = editor.signals;

    var container = new UI.Panel();
    container.setId('userTab');

    //

    var selectedNode = null;

    function build() {
        container.clear();

        if (selectedNode === null) return;

        var row = new UI.Row();

        // Keyword
        var keywordContainer = new UI.Div();
        keywordContainer.setId('keywordContainer')
        var keywordList = new UI.Div().setId('keywordList')
        var keywordText = new UI.Text('KEYWORD');
        keywordText.setId('keywordText')
        var addKeywordButton = new UI.Button('Add Another Keyword')
        addKeywordButton.setId('addKeywordButton')
        keywordContainer.add(keywordText)

        function removeSelectedValueForKeyword(e) {
            var id = e.target.parentNode.querySelector('input').dataset.id
            keywordList.dom.removeChild(e.target.parentNode)
            editor.signals.userSectionValueRemoved.dispatch(id)
        }

        var selectedValuesForVerbalEditor = editor.currentNodeSelectedValues.filter(selectedValues => selectedValues.section === 'Verbal Communication')
        selectedValuesForVerbalEditor.forEach(selectedValue => {
            var inputContainer = new UI.Div();
            var deleteButton = new UI.Button('Remove')
            deleteButton.setId('keywordDeleteButton').setDisplay('block')
            deleteButton.onClick(removeSelectedValueForKeyword)

            // sentence1
            let sentence1 = selectedValue.value
            var input = new UI.Input(selectedValue.value).setDataId(selectedValue.id).setWidth('130px');
            input.onChange(function () {
                sentence1 = this.getValue()
            })
            input.dom.addEventListener('input', inputUpdates)
            input.dom.style.marginTop = "5px"
            inputContainer.add(input)

            // add similairty checker button here
            var rowForSimiChecker = new UI.Row()
            var similairtyCheckerBtn = new UI.Button('Open Similarity Checker')
            similairtyCheckerBtn.setBackground('#4e4f4f')
            similairtyCheckerBtn.onClick(function () {
                if (!showCheckerRow) {
                    checkerRow.setDisplay('inline')
                    rowSimiResult.setDisplay('inline')
                } else {
                    checkerRow.setDisplay('none')
                    rowSimiResult.setDisplay('none')
                }
                showCheckerRow = !showCheckerRow
            })
            rowForSimiChecker.add(similairtyCheckerBtn)
            inputContainer.add(rowForSimiChecker)

            var checkerRow = new UI.Row().setDisplay('none')
            var showCheckerRow = false
            // sentence2
            let sentence2 = 'some else'
            var input = new UI.Input(sentence2).setWidth('100px')
            input.onChange(function () {
                sentence2 = this.getValue()
            })
            checkerRow.add(input)

            // OK Button
            var confirmBtn = new UI.Button('Check').setWidth('30px')
            confirmBtn.onClick(function () {
                use.load().then(model => {
                    // Embed an array of sentences.
                    const sentences = [
                        sentence1,
                        sentence2
                    ];
                    model.embed(sentences).then(embeddings => {
                        // `embeddings` is a 2D tensor consisting of the 512-dimensional embeddings for each sentence.
                        // So in this example `embeddings` has the shape [2, 512].
                        embeddings.print(true /* verbose */);
                        const sentenceX = embeddings.slice([0, 0], [1]);
                        const sentenceY = embeddings.slice([1, 0], [1]);
                        const sentenceITranspose = false;
                        const sentenceJTransepose = true;
                        const score =
                            sentenceX.matMul(sentenceY, sentenceITranspose, sentenceJTransepose)
                                .dataSync();
                        simiResult.setValue(parseFloat(score).toFixed(2) * 100 + '% ' + 'similar to your input')
                            .setColor('red')
                            .setFontSize('10px')
                        rowSimiResult.setDisplay('inline')
                    });
                });
            })
            checkerRow.add(confirmBtn)
            inputContainer.add(checkerRow)
            var rowSimiResult = new UI.Row().setDisplay('none')
            var simiResult = new UI.Text()
            rowSimiResult.add(simiResult)
            inputContainer.add(rowSimiResult)
            // end of similarity checker

            // start of generate synonym
            var synonymBtn = new UI.Button('Add Synonyms')
            synonymBtn.onClick(function () {
                fuzz()
                    .meansLike(sentence1)
                    .ask()
                    .then(res => {
                        if (res.length !== 0) {
                            let wordsList = []
                            for (let i = 0; i < 6; i++) {
                                wordsList.push(res[i].word)
                            }
                            editor.signals.enableSynonymDialog.dispatch(wordsList)
                            console.log(wordsList)
                        } else {
                            console.log(sentence1 + ' does NOT have synonyms')
                        }
                    })
            })
            inputContainer.add(synonymBtn)
            // end of generate synonym

            inputContainer.add(deleteButton)
            keywordList.add(inputContainer)

        })

        function inputUpdates(e) {            
            // if (!editor.addedWord || editor.fromInputChange) {
            //     var sectionDataToDispatch = {
            //         section: 'Verbal Communication',
            //         fieldName: 'input',
            //         service: 'custom',
            //         value: e.target.value,
            //         id: e.target.dataset.id,
            //         type: 'string'
            //     }
            //     editor.signals.userSectionValue.dispatch(sectionDataToDispatch)
            // }
        }

        // var inputContainer = new UI.Div();
        // var deleteButton = new UI.Button('Remove')
        // deleteButton.onClick(removeSelectedValueForKeyword)
        // var input = new UI.Input('').setDataId(userTabElementId++);
        // input.dom.addEventListener('input', inputUpdates)
        // input.dom.style.marginTop = "5px"
        // inputContainer.add(input)
        // inputContainer.add(deleteButton)
        // keywordList.add(inputContainer)
        keywordContainer.add(keywordList)
        keywordContainer.add(addKeywordButton)

        if (!selectedValuesForVerbalEditor.length) {
            // editor.fromInputChange = true            

            var inputContainer = new UI.Div();
            var deleteButton = new UI.Button('Remove')
            deleteButton.setId('keywordDeleteButton').setDisplay('block')
            deleteButton.onClick(removeSelectedValueForKeyword)

            // sentence1
            let sentence1 = 'Type something'
            var input = new UI.Input(sentence1).setDataId(uniqid()).setWidth('130px').setDisplay('inline');
            input.onChange(function () {
                sentence1 = this.getValue()
            })
            input.dom.addEventListener('input', inputUpdates)
            input.dom.style.marginBottom = "10px"
            inputContainer.add(input)

            // add similairty checker button here
            var rowForSimiChecker = new UI.Row()
            var similairtyCheckerBtn = new UI.Button('Open Similarity Checker')
            similairtyCheckerBtn.setBackground('#4e4f4f')
            similairtyCheckerBtn.onClick(function () {
                if (!showCheckerRow) {
                    checkerRow.setDisplay('inline')
                    rowSimiResult.setDisplay('inline')
                } else {
                    checkerRow.setDisplay('none')
                    rowSimiResult.setDisplay('none')
                }
                showCheckerRow = !showCheckerRow
            })
            rowForSimiChecker.add(similairtyCheckerBtn)
            inputContainer.add(rowForSimiChecker)

            var checkerRow = new UI.Row().setDisplay('none')
            var showCheckerRow = false
            // sentence2
            let sentence2 = 'some else'
            var input = new UI.Input(sentence2).setWidth('100px')
            input.onChange(function () {
                sentence2 = this.getValue()
            })
            checkerRow.add(input)

            // OK Button
            var confirmBtn = new UI.Button('Check').setWidth('30px')
            confirmBtn.onClick(function () {
                use.load().then(model => {
                    // Embed an array of sentences.
                    const sentences = [
                        sentence1,
                        sentence2
                    ];
                    model.embed(sentences).then(embeddings => {
                        // `embeddings` is a 2D tensor consisting of the 512-dimensional embeddings for each sentence.
                        // So in this example `embeddings` has the shape [2, 512].
                        embeddings.print(true /* verbose */);
                        const sentenceX = embeddings.slice([0, 0], [1]);
                        const sentenceY = embeddings.slice([1, 0], [1]);
                        const sentenceITranspose = false;
                        const sentenceJTransepose = true;
                        const score =
                            sentenceX.matMul(sentenceY, sentenceITranspose, sentenceJTransepose)
                                .dataSync();
                        simiResult.setValue(parseFloat(score).toFixed(2) * 100 + '% ' + 'similar to your input')
                            .setColor('red')
                            .setFontSize('10px')
                        rowSimiResult.setDisplay('block')
                    });
                });
            })
            checkerRow.add(confirmBtn)
            inputContainer.add(checkerRow)
            var rowSimiResult = new UI.Row().setDisplay('none')
            var simiResult = new UI.Text()
            rowSimiResult.add(simiResult)
            inputContainer.add(rowSimiResult)
            // end of similarity checker

            // start of generate synonym
            var synonymBtn = new UI.Button('Add Synonyms')
            synonymBtn.onClick(function () {
                fuzz()
                    .meansLike(sentence1)
                    .ask()
                    .then(res => {
                        if (res.length !== 0) {
                            let wordsList = []
                            for (let i = 0; i < 6; i++) {
                                wordsList.push(res[i].word)
                            }
                            editor.signals.enableSynonymDialog.dispatch(wordsList)
                            console.log(wordsList)
                        } else {
                            console.log(sentence1 + ' does NOT have synonyms')
                        }
                    })
            })
            inputContainer.add(synonymBtn)
            // end of generate synonym

            inputContainer.add(deleteButton)
            keywordList.add(inputContainer)
            keywordContainer.add(keywordList)
            keywordContainer.add(addKeywordButton)
        }

        let original = ''
        editor.signals.addSynonymKeyWord.add(function (synonym) {
            original = synonym
            addKeywordButton.dom.dispatchEvent(new Event("click"))
        })
        addKeywordButton.onClick(function(e) {              
            // editor.fromInputChange = true          
            var inputContainer = new UI.Div();
            var deleteButton = new UI.Button('Remove')
            deleteButton.setId('keywordDeleteButton').setDisplay('block')
            deleteButton.onClick(removeSelectedValueForKeyword)
            // sentence1
            let sentence1 = ''
            if (original !== '') {
                sentence1 = original
            } else {
                sentence1 = 'Type something'
            }

            var inputSentence1 = new UI.Input(sentence1).setDataId(uniqid()).setWidth('130px');
            inputSentence1.onChange(function () {
                sentence1 = this.getValue()
            })
            inputSentence1.dom.addEventListener('input', inputUpdates)
            if (original !== '') { 
                // editor.fromInputChange = false                               
                inputSentence1.dom.dispatchEvent(new Event("input"))                
            }                     
            original = ''             
            inputSentence1.dom.style.marginBottom = "10px"
            inputContainer.add(inputSentence1)

            // add similairty checker button here
            var rowForAddedSimiChecker = new UI.Row()
            var similairtyCheckerBtn = new UI.Button('Open Similarity Checker')
            similairtyCheckerBtn.setBackground('#4e4f4f')
            similairtyCheckerBtn.onClick(function () {
                if (!showCheckerRow) {
                    checkerRow.setDisplay('inline')
                    rowSimiResult.setDisplay('inline')
                } else {
                    checkerRow.setDisplay('none')
                    rowSimiResult.setDisplay('none')
                }
                showCheckerRow = !showCheckerRow
            })
            rowForAddedSimiChecker.add(similairtyCheckerBtn)
            inputContainer.add(rowForAddedSimiChecker)

            var checkerRow = new UI.Row().setDisplay('none')
            var showCheckerRow = false
            // sentence2
            let sentence2 = 'some else'
            var input = new UI.Input(sentence2).setWidth('100px')
            input.onChange(function () {
                sentence2 = this.getValue()
            })
            checkerRow.add(input)

            // OK Button
            var confirmBtn = new UI.Button('Check').setWidth('30px')
            confirmBtn.onClick(function () {
                use.load().then(model => {
                    // Embed an array of sentences.
                    const sentences = [
                        sentence1,
                        sentence2
                    ];
                    model.embed(sentences).then(embeddings => {
                        // `embeddings` is a 2D tensor consisting of the 512-dimensional embeddings for each sentence.
                        // So in this example `embeddings` has the shape [2, 512].
                        embeddings.print(true /* verbose */);
                        const sentenceX = embeddings.slice([0, 0], [1]);
                        const sentenceY = embeddings.slice([1, 0], [1]);
                        const sentenceITranspose = false;
                        const sentenceJTransepose = true;
                        const score =
                            sentenceX.matMul(sentenceY, sentenceITranspose, sentenceJTransepose)
                                .dataSync();
                        simiResult.setValue(parseFloat(score).toFixed(2) * 100 + '% ' + 'similar to your input')
                            .setColor('red')
                            .setFontSize('10px')
                        rowSimiResult.setDisplay('inline')
                    });
                });
            })
            checkerRow.add(confirmBtn)

            inputContainer.add(checkerRow)
            var rowSimiResult = new UI.Row().setDisplay('none')
            var simiResult = new UI.Text()
            rowSimiResult.add(simiResult)
            inputContainer.add(rowSimiResult)
            // end of similarity checker

            // start of generate synonym
            var synonymBtn = new UI.Button('Add Synonyms')
            synonymBtn.onClick(function () {
                fuzz()
                    .meansLike(sentence1)
                    .ask()
                    .then(res => {
                        if (res.length !== 0) {
                            let wordsList = []
                            for (let i = 0; i < 6; i++) {
                                wordsList.push(res[i].word)
                            }
                            editor.signals.enableSynonymDialog.dispatch(wordsList)
                            console.log(wordsList)
                        } else {
                            console.log(sentence1 + ' does NOT have synonyms')
                        }
                    })
            })
            inputContainer.add(synonymBtn)
            // end of generate synonym

            inputContainer.add(deleteButton)
            keywordList.add(inputContainer)
            keywordContainer.add(keywordList)
            keywordContainer.add(addKeywordButton)
        })


        // Visual Communtication

        var visualCommunicationContainer = new UI.Div().setId('visualCommunicationContainer');
        var visualCommunticationList = new UI.Div().setId('visualCommunticationList')

        function removeSelectedValueForVisualCommunication(e) {
            var id = e.target.parentNode.querySelector('select').dataset.id
            visualCommunticationList.dom.removeChild(e.target.parentNode)
            editor.signals.userSectionValueRemoved.dispatch(id)
        }

        function onVisualCommunicationSelection(e) {
            var val = parseInt(e.target.value)
            var selectedUserItem = optionsForVisualCommunication[val]

            var sectionDataToDispatch = {
                section: 'Visual Communication',
                fieldName: selectedUserItem.fieldName,
                service: selectedUserItem.service,
                value: selectedUserItem.value,
                id: e.target.dataset.id,
                type: selectedUserItem.type
            }

            editor.signals.userSectionValue.dispatch(sectionDataToDispatch)
        }

        var selectedValuesForVisualEditor = editor.currentNodeSelectedValues.filter(selectedValues => selectedValues.section === 'Visual Communication')
        var photoFieldsForVisualCommunication = editor.userConditionItems.filter(userCondition => userCondition.section === 'photo')
        var optionsForVisualCommunication = []
        photoFieldsForVisualCommunication.forEach(photoSection => {
            if (photoSection.values) {
                photoSection.values.forEach(section => {
                    photoSection.value = section
                    optionsForVisualCommunication.push(Object.assign({}, photoSection))
                })
            } else {
                photoSection.value = photoSection.fieldName
                optionsForVisualCommunication.push(Object.assign({}, photoSection))
            }

        })
        selectedValuesForVisualEditor.forEach(selectedValue => {
            var inputContainer = new UI.Div();
            var visualCommunticationDeleteButton = new UI.Button('Remove')
            visualCommunticationDeleteButton.onClick(removeSelectedValueForVisualCommunication)
            visualCommunticationDeleteButton.setId('visualCommunticationDeleteButton')
            var visualCommunticationSelector = new UI.Select().setDataId(selectedValue.id)
            var selectedUserCondition = optionsForVisualCommunication.findIndex(userCondition => userCondition.value === selectedValue.value)
            visualCommunticationSelector.setOptions(optionsForVisualCommunication.map(userCondition => userCondition.value)).setValue(selectedUserCondition);
            visualCommunticationSelector.onChange(onVisualCommunicationSelection);

            inputContainer.add(visualCommunticationSelector)
            inputContainer.add(visualCommunticationDeleteButton)

            visualCommunticationList.add(inputContainer);
        })

        // if (!selectedValuesForVisualEditor.length) {
        //     var inputContainer = new UI.Div();
        //     var visualCommunticationDeleteButton = new UI.Button('Remove')
        //     visualCommunticationDeleteButton.setId('visualCommunticationDeleteButton')
        //     visualCommunticationDeleteButton.onClick(removeSelectedValueForVisualCommunication)
        //     var visualCommunticationSelector = new UI.Select().setDataId(userTabElementId++)
        //     visualCommunticationSelector.setId('visualCommunticationSelector')
        //     visualCommunticationSelector.setOptions(optionsForVisualCommunication.map(userCondition => userCondition.value)).setValue(0);
        //     visualCommunticationSelector.onChange(onVisualCommunicationSelection);
        //     visualCommunticationSelector.dom.dispatchEvent(new Event("change"))
        //     inputContainer.add(visualCommunticationSelector)
        //     inputContainer.add(visualCommunticationDeleteButton)

        //     visualCommunticationList.add(inputContainer);
        // }




        var addVisualCommunticationButton = new UI.Button('Add Condition')

        addVisualCommunticationButton.setId('addVisualCommunticationButton')
        addVisualCommunticationButton.onClick(function (e) {
            var inputContainer = new UI.Div();
            var visualCommunticationDeleteButton = new UI.Button('Remove')
            visualCommunticationDeleteButton.setId('visualCommunticationDeleteButton')
            visualCommunticationDeleteButton.onClick(removeSelectedValueForVisualCommunication)
            var visualCommunticationSelector = new UI.Select().setDataId(uniqid())
            visualCommunticationSelector.setId('visualCommunticationSelector')
            visualCommunticationSelector.setOptions(optionsForVisualCommunication.map(userCondition => userCondition.value)).setValue(0);
            visualCommunticationSelector.onChange(onVisualCommunicationSelection);
            visualCommunticationSelector.dom.dispatchEvent(new Event("change"))
            inputContainer.add(visualCommunticationSelector)
            inputContainer.add(visualCommunticationDeleteButton)

            visualCommunticationList.add(inputContainer);
        })

        visualCommunicationContainer.add(visualCommunticationList)
        visualCommunicationContainer.add(addVisualCommunticationButton)

        // Analytics User

        var analyticsContainer = new UI.Div();
        analyticsContainer.setId('analyticsContainer')
        var analyticsList = new UI.Div().setId('analysisList')
        analyticsContainer.add(analyticsList)

        function removeSelectedValueForAnalytics(e) {
            var id = e.target.parentNode.querySelector('select').dataset.id
            analyticsList.dom.removeChild(e.target.parentNode)
            editor.signals.userSectionValueRemoved.dispatch(id)
        }

        function onAnalyticsSelection(e) {


            // let val = parseInt(e.target.value)
            // let selectedUserItem = editor.userConditionItems[val]
            // let sectionDataToDispatch = {
            //     section: 'Analytics',
            //     fieldName: selectedUserItem.fieldName,
            //     service: selectedUserItem.service,
            //     value: selectedUserItem.fieldName,
            //     id: e.target.dataset.id,
            //     type: selectedUserItem.type
            // }

            // editor.signals.userSectionValue.dispatch(sectionDataToDispatch)
        }

        var selectedValuesForAnalytics = editor.currentNodeSelectedValues.filter(selectedValues => selectedValues.section === 'Analytics')
        selectedValuesForAnalytics.forEach(selectedValue => {
            var inputContainer = new UI.Div();
            var analyticsDeleteButton = new UI.Button('Remove')
            analyticsDeleteButton.setId('analyticsDeleteButton')
            analyticsDeleteButton.onClick(removeSelectedValueForAnalytics)

            var analyticsSelector = new UI.Select().setDataId(selectedValue.id)
            var selectedAnalyticCondition = editor.userConditionItems.findIndex(userCondition => userCondition.fieldName === selectedValue.fieldName)
            analyticsSelector.setOptions(['Custom Condition']).setValue(selectedAnalyticCondition);
            analyticsSelector.onChange(onAnalyticsSelection);

            inputContainer.add(analyticsSelector)
            inputContainer.add(analyticsDeleteButton)

            analyticsList.add(inputContainer);
        })

        // var inputContainer = new UI.Div();
        // var analyticsDeleteButton = new UI.Button('Remove')
        // analyticsDeleteButton.onClick(removeSelectedValueForAnalytics)

        // let analyticsSelector = new UI.Select().setDataId(userTabElementId++)
        // analyticsSelector.setOptions(['Custom Condition']).setValue(0);
        // analyticsSelector.onChange(onAnalyticsSelection);

        // inputContainer.add(analyticsSelector)
        // inputContainer.add(analyticsDeleteButton)

        // analyticsList.add(inputContainer);

        if (!selectedValuesForAnalytics.length) {
            var inputContainer = new UI.Div();
            var analyticsDeleteButton = new UI.Button('Remove')
            analyticsDeleteButton.onClick(removeSelectedValueForAnalytics)
            analyticsDeleteButton.setId('analyticsDeleteButton')

            var analyticsSelector = new UI.Select().setDataId(uniqid())
            analyticsSelector.setId('analyticsSelector')
            analyticsSelector.setOptions(['Custom Condition']).setValue(0);
            analyticsSelector.onChange(onAnalyticsSelection);
            analyticsSelector.dom.dispatchEvent(new Event("change"))
            inputContainer.add(analyticsSelector)
            inputContainer.add(analyticsDeleteButton)

            analyticsList.add(inputContainer);
        }
        var addAnalyticsButton = new UI.Button('Create Custom Condition')
        addAnalyticsButton.setId('addAnalyticsButton')
        addAnalyticsButton.onClick(function (e) {
            var inputContainer = new UI.Div();
            var analyticsDeleteButton = new UI.Button('Remove')
            analyticsDeleteButton.onClick(removeSelectedValueForAnalytics)
            analyticsDeleteButton.setId('analyticsDeleteButton')

            var analyticsSelector = new UI.Select().setDataId(uniqid())
            analyticsSelector.setId('analyticsSelector')
            analyticsSelector.setOptions(['Custom Condition']).setValue(0);
            analyticsSelector.onChange(onAnalyticsSelection);
            analyticsSelector.dom.dispatchEvent(new Event("change"))
            inputContainer.add(analyticsSelector)
            inputContainer.add(analyticsDeleteButton)

            analyticsList.add(inputContainer);
        })

        analyticsContainer.add(analyticsList)
        analyticsContainer.add(addAnalyticsButton)


        var elements = [
            { title: "Verbal Communication", node: keywordContainer},
            { title: "Visual Communication", node: visualCommunicationContainer},
            { title: "Analytics", node: analyticsContainer}
        ]

        var button = new UI.Collapsable(elements, editor).setWidth('100%')
        button.onClick(onSelectedNodeType);
        row.add(button);
        container.add(row);

    }

    function onSelectedNodeType() {

        // selected.name = this.dom.innerText
        // selected.type = selected.name
        // selected.phase = 'needsAsset'
        // signals.animationPhaseChanged.dispatch(selected);
        // signals.animationRenamed.dispatch(selected);
    }

    //

    // signals.editorCleared.add( function () {

    // 	selected = null;
    // 	build();

    // } );

    signals.nodeSelected.add(function (node) {
        if (node.data.category === 'User') {
            selectedNode = node;
            build();
        }
    });

    // signals.effectCompiled.add(build);

	/*
	signals.timeChanged.add( function () {

		if ( selected !== null ) {

			for ( var key in values ) {

				values[ key ].setValue( selected.module.parameters[ key ].value );

			}

		}

	} );
	*/

    return container;

};

export default UserTab



//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/UserTab.js
// module id = null
// module chunks = 